import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../../lib/supabase';

// /u/:username — where an @mention links. Resolves the handle and replaces
// itself with /profile/:id, so Back skips this hop. PublicProfileScreen
// already sends your own id on to /profile.
//
// A mention is written as text, so it can name a handle nobody owns (or one
// since changed); that ends here with a plain "no member" note.
const UsernameRedirect = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.rpc('get_member_id_by_username', { p_username: username });
      if (cancelled) return;
      if (error) console.error('get_member_id_by_username:', error);
      if (data) navigate(`/profile/${data}`, { replace: true });
      else setMissing(true);
    })();
    return () => { cancelled = true; };
  }, [username, navigate]);

  if (!missing) return null;

  return (
    <div className="px-4 py-10 text-center">
      <p className="text-[15px] font-medium text-primary">No member goes by @{username}</p>
      <p className="text-sm mt-1" style={{ color: 'var(--text-tertiary)' }}>
        They may have changed their username.
      </p>
      <button
        type="button"
        onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/feed'))}
        className="mt-5 inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium text-white transition-all hover:brightness-110 active:scale-[0.98]"
        style={{ backgroundColor: 'var(--brand-primary)' }}
      >
        <ArrowLeft size={16} /> Go back
      </button>
    </div>
  );
};

export default UsernameRedirect;
